import React from 'react';
import scaleSize from '../../utils/scale-size';

export default ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(34)}
    height={scaleSize(24)}
    viewBox="0 0 34 24"
    className={className}
  >
    <path
      fill="none"
      fillRule="evenodd"
      stroke="#CCC"
      strokeWidth="4"
      strokeLinejoin="round"
      strokeLinecap="round"
      d="M32 2L12 22 2 12"
    />
  </svg>
);
